import apiClient from './_client';

export default {
    store(data) {
        return apiClient.post('tests', data);
    },
    show(testId) {
        return apiClient.get('tests/' + testId);
    },
    delete(testId) {
        return apiClient.delete('tests/' + testId);
    },
    index(status) {
        return apiClient.get('tests', {status: status});
    },
    update(test) {
        return apiClient.put('tests/' + test.id, test);
    },
    payment(test, paymentIntentId, invoiceId) {
        return apiClient.post('tests/payment/' + test.id, {
            paymentIntentId,
            invoiceId
        });
    },
    createIntent(test, coupon) {
        return apiClient.post('tests/create-intent/' + test.id, {couponId: coupon ? coupon.id : null});
    },
    answers(testId) {
        return apiClient.get('tests/answers/' + testId).then(response => {
            return response.answers;
        });
    },
    toggleAnswerLike(answerId) {
        return apiClient.get('tests/answers/' + answerId + '/toggle-like').then(response => {
            return response.is_liked;
        });
    },
    toggleAnswerHide(answerId) {
        return apiClient.get('tests/answers/' + answerId + '/toggle-hide').then(response => {
            return response.is_hidden;
        });
    },
    uploadImage(test, payload) {
        return apiClient.post('tests/' + test.id + '/image', payload);
    },
}
